// extracted by mini-css-extract-plugin
export var documentation = "_ki-1";
export var menu = "_ki-0";